// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/content-documents/media-document/source-name/source-name.component.scss
// module id = 167
// module chunks = 0